const getFileExtension = filename => {
    const ext = filename?.split(/[?#]/, 1)[0]?.split('.').pop();
    return ext && ext !== filename ? ext : '';
};

export const resolveDownloadFileName = (fileName, fileDisplayName) => {
    const preferredName = String(fileDisplayName || fileName || 'file').trim() || 'file';
    if (getFileExtension(preferredName)) {
        return preferredName;
    }

    const storageExtension = getFileExtension(fileName);
    return storageExtension ? `${preferredName}.${storageExtension}` : preferredName;
};
